// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"bb6c12c0","225":"d8335ca6","908":"f68f07a2","922":"3d178205"}[chunkId] + ".css";
};